export class EventEmitterBo {
    isCreate: boolean = false;
    TimesheetId: string = "00000000-0000-0000-0000-000000000000";
    ClientList: any = [];
    clientid: string;
    employeeid: string;
    serviceid: string;
    starttime: string;
    endtime: string;
    timesheetid: string;
    startdate: string = null;
    enddate: string = null;
    errortype: string = null;
    evvstatus: string = null;


}



// export class EVVTimesheetBO {
//     authorizationId: string;
//     employeeId: string;
//     clientId: string;
//     timesheets: saveEvvTimesheetBO;
// }



// export class saveEvvTimesheetBO {
//     id: string;
//     clientId: string;
//     employeeId: string;
//     clientAuthorizationId: string;
//     serviceId: string;
//     startTime: string;
//     endTime: string;
//     totalHours: number=0;
//     multiplesessionBO: MultiplesessionBO[]=[];

// }


export class saveEvvTimesheetBO {
    id: string;
    employeeId: string;
    clientId: string;
    serviceId: string;
    clientAuthorizationId: string;
    visitStartTime: string;
    visitEndTime: string;
    totalHours: number = 0;
    visitNote: string;
    reasonForModify: string;
    multiplesessionBO: MultipleSessionBO[] = [];
}

export class MultipleSessionBO {
    visitStartTime: string;
    visitEndTime: string;
    totalHours: number = 0;
}




// export interface ManualVisitBO {
//     id: string;
//     employeeId: string;
//     clientId: string;
//     serviceId: string;
//     clientAuthorizationId: string;
//     visitStartTime: string;
//     visitEndTime: string;
//     totalHours: number;
//     visitNote: string;
//     reasonForModify: string;
// }





// export class MultiplesessionBO {
//     startTime: string;
//     endTime: string;
//     totalHours: number=0;
// }


export class DeletepermissionBO {
    evvId: string;
    admin_Password: string;
}




export class getEvvtimesheetBO {
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "clientName";
    orderType: string = "asc";
    matchCase: boolean = false;
    operator: string = "startswith";
    type: string = "string";
    field: string = "clientName";
    value: string = "";
    agencyId: string;
    visitStartTime: string;
    visitEndTime: string;
    clientId: string | null;
    employeeId: string | null;
    locationLid: string | null;
    serviceId: string | null;
    visitTypeName: string | null;
    isEvvArchived: boolean;
    isApproved: boolean | null;
    isOverNight: boolean | null;
    isExported: string;
    errortype: string;
    visitProgressStatus: string | null;
    evvstatus: any | null;
    isModifiedFilter:boolean;
}


export class ActivityLstBO {
    activityId: string;
    activityName: string;
    isSelected: boolean;
}


export class filters {
    filterStartDate: string = null;
    filterEndDate: string = null;
    filterEmployee: number = null;
    filterEmployeevalue: number = null;
    filterClient: number = null;
    filterClientvalue: number = null;
    filtermasterservice: number = null;
    errortype: string = null;
    evvstatus: string = null;
}

export class DeleteAllBO {
    evvId: string[];
    admin_Password: string;
}

export class startenddateBo {
    startDate: string;
    endDate: string;
}

export class functionpermission {
    visitscreate: boolean = true;
    // evvtimesheetupdate:boolean=true;
    // evvtimesheetdelete:boolean=true;
    // evvtimesheetmultipleupdate:boolean=true;
}

export class saveactivitybo {
    evvTsId: string;
    activities: string[];
}

export class BulkT2025UpdateBO {
    startDate: string = null;
    endDate: string = null;
    clientId: string = "00000000-0000-0000-0000-000000000000";
    employeeId: string = "00000000-0000-0000-0000-000000000000";
    updateAuthId: string = "00000000-0000-0000-0000-000000000000";
    serviceId: string = "00000000-0000-0000-0000-000000000000";
    updateServiceId: string = "00000000-0000-0000-0000-000000000000";
}

export class MultipleAccecpt_RejectBO {
    clientAuthId: string;
    purchaseReqId: string;
    acceptType:string;
} 